module.exports = __webpack_public_path__ + "static/desktop/img/calendar-5.796b4d17.png";